import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { CoreLogType } from "__generated__/enums";
import { intl } from "LocaleWrapper";

const CoreLogTypeSelect = ({ ...rest }: Omit<SelectProps<CoreLogType, false>, "fetchOptions" | "paginated">) => {
	return (
		<Select
			{...rest}
			fetchOptions={Object.values(CoreLogType)}
			getOptionLabel={option => intl.formatMessage({ id: option })}
			disableSearch
		/>
	);
};

export default CoreLogTypeSelect;
